import { Box, HStack, Text } from '@chakra-ui/react';
import { WarningIcon } from 'assets/icons/v2';
import { NovaIcon } from 'components/ui/novaIcon';
import { useIsScrolled } from 'hooks/utils/useIsScrolled';
import React, { ReactElement } from 'react';
import { Z_INDEX } from 'styles/zIndex';
import { TopBarProps } from 'types/Layout';

// make the props themself not optional, while maintaining mapped type like 'TopBarProps['worksheetEditorOptions']'
type Props = NonNullable<TopBarProps['worksheetEditorOptions']>;

export const TopBarWorksheetEditor = ({
  isViewMode,
  title,
  ButtonComponents,
}: Props): ReactElement => {
  const scrollThresholdInPx = 150;
  const isFloating = useIsScrolled(scrollThresholdInPx);

  return (
    <Box
      top="0"
      position="sticky"
      zIndex={Z_INDEX.SEARCH_BAR}
      bg="background.primary"
      borderBottom="default"
      borderColor="border.accent"
    >
      <Box maxWidth="1920px" width="100%" margin="0 auto" padding="15px 80px">
        {!isFloating ? (
          <Box
            maxW="1920px"
            py="xs"
            width="100%"
            margin="0 auto"
            display="flex"
            alignItems="center"
            gap="10px"
            justifyContent="space-between"
          >
            <Text textStyle="h3.medium" color="text.primary" textAlign="center" width="100%">
              Arbeitsblatt bearbeiten
            </Text>
          </Box>
        ) : (
          <HStack justifyContent="space-between" px="4xl">
            <Text textStyle="h3.medium" color="text.primary">
              {title}
            </Text>
            {ButtonComponents}
          </HStack>
        )}
      </Box>

      {isViewMode && (
        <HStack
          bg="background.highlight.yellow"
          position="absolute"
          top="100%"
          left="0"
          right="0"
          py="m"
          gap="10px"
          alignItems="center"
          justifyContent="center"
          maxWidth="1920px"
          width="100%"
          margin="0 auto"
          padding="15px 80px"
        >
          <NovaIcon icon={WarningIcon} size="l" color="icon.warning" />
          <Text textStyle="body.s.medium" color="text.primary" textAlign="center">
            Du bist gerade im Vorschau-Modus. Klicke auf „Bearbeiten“, um weiterzumachen.
          </Text>
        </HStack>
      )}
    </Box>
  );
};
